// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { List, ListItem } from 'client/components/core/lists';
import { Separator } from 'client/components/separator';
import { branch } from 'core/utils';
import { colors, columns, media, units } from 'client/styles';
import { isEmpty } from 'lodash';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  icon: string,
  list?: Array<string>,
  text: string,
  title: string
};

/**
 * `ListWrapper` styled component.
 */

const ListWrapper = styled.div`
  padding-top: ${units(2)};

  ul > li {
    margin: 2px 0;
    padding-left: ${units(4.5)};
    position: relative;

    &::before {
      background-color: ${colors.brandPrimary};
      content: '';
      height: 1px;
      left: 0;
      position: absolute;
      top: 50%;
      width: ${units(2)};
    }
  }
`;

/**
 * Icon style.
 */

const iconStyle = `
  width: 100%;
  max-width: none;

  ${media.min.smQuery(`
    max-width: ${columns(10)}%;
    width: ${columns(10)}%;
  `)}
`;

/**
 * `Agents` component.
 */

const Agents = ({ icon, list = [], text, title }: Props): React$Element<*> => (
  <Layout overflow={'hidden'}>
    <Row>
      <Layout
        alignItemsSm={'center'}
        displaySm={'flex'}
      >
        <Col
          sm={5}
          xs={10}
          xsOffset={1}
        >
          <Layout
            marginBottom={units(4)}
            marginBottomMd={units(6)}
            maxWidth={units(60)}
          >
            <Text.H2
              color={colors.brandPrimary}
              marginBottom={0}
            >
              {title}
            </Text.H2>
          </Layout>

          <Row>
            <Col xs={2}>
              <Layout
                display={'none'}
                displayMd={'block'}
              >
                <Separator.Horizontal topRight/>
              </Layout>
            </Col>

            <Col
              md={10}
              xs={12}
            >
              <Text.Paragraph>
                <RawHtml.span>
                  {text}
                </RawHtml.span>
              </Text.Paragraph>

              {branch(!isEmpty(list),
                <ListWrapper>
                  <List>
                    {list.map((item: string, index: number): React$Element<*> => (
                      <ListItem
                        block
                        key={index}
                      >
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </ListWrapper>
              )}
            </Col>
          </Row>
        </Col>

        <Col
          md={4}
          mdOffset={1}
          sm={5}
          smOffset={0}
          xs={10}
          xsOffset={1}
        >
          <Layout
            paddingTop={units(10)}
            paddingTopSm={0}
          >
            <Icon
              icon={icon}
              styles={iconStyle}
            />
          </Layout>
        </Col>
      </Layout>
    </Row>
  </Layout>
);

/**
 * Export `Agents` component.
 */

export default Agents;



// WEBPACK FOOTER //
// ../src/client/components/for-agents/agents.js